import { useEffect } from 'react';

export function useJsonLd(data: Record<string, unknown> | Record<string, unknown>[]) {
  useEffect(() => {
    const items = Array.isArray(data) ? data : [data];
    const scripts = items.map((item) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.text = JSON.stringify(item);
      document.head.appendChild(script);
      return script;
    });
    return () => {
      scripts.forEach((s) => s.remove());
    };
  }, [data]);
}